import { supabase } from './supabaseClient';

async function callAdminCustomers<T = Record<string, unknown>>(action: string, body: Record<string, unknown> = {}): Promise<T> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in');

  const res = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/admin-customers`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      'Content-Type': 'application/json',
      apikey: import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({ action, ...body }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error ?? `Request failed (${res.status})`);
  return json as T;
}

// Account deletion moved to ERP's Customers page — rxk's own admin no
// longer exposes it, though the shared admin-customers edge function
// still supports the delete_customer action for that caller.
export const adminCustomerApi = {
  updateEmail: (customer_id: string, email: string) => callAdminCustomers('update_email', { customer_id, email }),
  setPassword: (customer_id: string, password: string) => callAdminCustomers('set_password', { customer_id, password }),
};
